/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Remove_Day_ConfirmInputs */

const en_us2_plan_build_remove_day_confirm = /** @type {(inputs: Plan_Build_Remove_Day_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete workout`)
};

const pt_br2_plan_build_remove_day_confirm = /** @type {(inputs: Plan_Build_Remove_Day_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir treino`)
};

const es_419_plan_build_remove_day_confirm = /** @type {(inputs: Plan_Build_Remove_Day_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar entrenamiento`)
};

const pt_pt2_plan_build_remove_day_confirm = /** @type {(inputs: Plan_Build_Remove_Day_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar treino`)
};

const fr_fr2_plan_build_remove_day_confirm = /** @type {(inputs: Plan_Build_Remove_Day_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la séance`)
};

const de_de2_plan_build_remove_day_confirm = /** @type {(inputs: Plan_Build_Remove_Day_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training löschen`)
};

const it_it2_plan_build_remove_day_confirm = /** @type {(inputs: Plan_Build_Remove_Day_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina allenamento`)
};

/**
* | output |
* | --- |
* | "Delete workout" |
*
* @param {Plan_Build_Remove_Day_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_remove_day_confirm = /** @type {((inputs?: Plan_Build_Remove_Day_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Remove_Day_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_remove_day_confirm(inputs)
	if (locale === "es-419") return es_419_plan_build_remove_day_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_remove_day_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_remove_day_confirm(inputs)
	if (locale === "de-DE") return de_de2_plan_build_remove_day_confirm(inputs)
	if (locale === "it-IT") return it_it2_plan_build_remove_day_confirm(inputs)
	return en_us2_plan_build_remove_day_confirm(inputs)
});
export { plan_build_remove_day_confirm as "plan-build.remove_day_confirm" }